function scrollToTarget() {
    var targetDiv = document.getElementById('scroll-section-landingpage');
    if (targetDiv) {
        targetDiv.scrollIntoView({ behavior: 'auto' }); // Disable smooth scrolling temporarily
        setTimeout(function () {
            targetDiv.scrollIntoView({ behavior: 'smooth' }); // Enable smooth scrolling after a short delay
        }, 1);
    }
}

/**************************/
/* Hero Images 2 girls Effect */
/**************************/

function isHeroImageInViewport(el) {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const topRelativeToViewport = (rect.top + rect.height / 2) / windowHeight;

  return topRelativeToViewport >= 0.35 && topRelativeToViewport <= 0.65;
}

function setHeroImageBorderRadius(image) {
  image.style.transition = 'border-radius 1s';

  if (isHeroImageInViewport(image)) {
    image.style.borderRadius = '0%';
  } else {
    image.style.borderRadius = '50% 0';
  }
}

function updateHeroImageBorderRadius() {
  const image = document.querySelector('.profiles-container img');

  if (image) {
    setHeroImageBorderRadius(image);
  }
}

window.addEventListener('scroll', updateHeroImageBorderRadius);
updateHeroImageBorderRadius();


/**************************/
/* Typing Text HERO Effect */
/**************************/

const dynamicText = document.querySelector(".typing-text h1 span");
const words = ["Colorful Pancake Baking Mixes!", "Flavored Chocolate Pretzels!", "Healthy Mueslis!", "Bread Baking Mixes!",  "Exciting Spices!"];
// Variables to track the position and deletion status of the word
let wordIndex = 0;
let charIndex = 0;
let isDeleting = false;
const typeEffect = () => {
    const currentWord = words[wordIndex];
    const currentChar = currentWord.substring(0, charIndex);
    dynamicText.textContent = currentChar;
    dynamicText.classList.add("stop-blinking");
    if (!isDeleting && charIndex < currentWord.length) {
        // If condition is true, type the next character
        charIndex++;
        setTimeout(typeEffect, 100);
    } else if (isDeleting && charIndex > 0) {
        // If condition is true, remove the previous character
        charIndex--;
        setTimeout(typeEffect, 50);
    } else {
        // If word is deleted then switch to the next word
        isDeleting = !isDeleting;
        dynamicText.classList.remove("stop-blinking");
        wordIndex = !isDeleting ? (wordIndex + 1) % words.length : wordIndex;
        setTimeout(typeEffect, 1200);
    }
}
typeEffect();

